import ConfirmationDialog from "../shared/ConfirmationDialog";

interface DeleteConfirmationDialogProps {
  open: boolean;
  contestName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteConfirmationDialog({
  open,
  contestName,
  onConfirm,
  onCancel,
}: DeleteConfirmationDialogProps) {
  return (
    <ConfirmationDialog
      open={open}
      title="Potwierdź usunięcie zgłoszenia"
      message={`Czy na pewno chcesz usunąć swoje zgłoszenie na turniej "${contestName}"? Tej operacji nie można cofnąć.`}
      confirmText="Usuń"
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmColor="error"
    />
  );
}
